import { type AppDispatch, type RootState } from "features/Application/globaltypes/redux";
import TagsManage from "features/Library/Common/TagsManage/TagsManage";
import { bindAction } from "interfaces";
import { connect } from "react-redux";
import { normalizedTagsSelector } from "../state/selectors";
import { addTagsToEmbeddedVideos, fetchEmbeddedVideosTags } from "../state/thunks/EmbeddedVideosTagsThunk";

/* istanbul ignore next */
const mapStateToProps = (state: RootState) => ({
  tags: normalizedTagsSelector(state),
});

/* istanbul ignore next */
const mapDispatchToProps = (dispatch: AppDispatch) => ({
  fetchTags: bindAction(fetchEmbeddedVideosTags, dispatch),
  onConfirmAction: bindAction(addTagsToEmbeddedVideos, dispatch),
});

export default connect(mapStateToProps, mapDispatchToProps)(TagsManage);
